import React, { Component } from 'react';
import loadable from '@loadable/component';
import { Route, Switch } from 'react-router-dom';

const routes = [
  {
    path: '/',
    exact: true,
    component: loadable(() =>
      import(/* webpackChunckName: 'mirroring' */ './mirroring'),
    ),
  },
  {
    path: '/error',
    exact: true,
    component: loadable(() =>
      import(/* webpackChunckName: 'error' */ './error'),
    ),
  },
];

export default class extends Component {
  render() {
    return (
      <Switch>
        {routes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
      </Switch>
    );
  }
}
